import * as React from "react"
import { SVGProps } from "react"

export const ProCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2559 4.41075C17.5814 4.73619 17.5814 5.26382 17.2559 5.58926L8.08926 14.7559C7.76382 15.0814 7.23618 15.0814 6.91074 14.7559L2.74408 10.5893C2.41864 10.2638 2.41864 9.73619 2.74408 9.41075C3.06951 9.08531 3.59715 9.08531 3.92259 9.41075L7.5 12.9882L16.0774 4.41075C16.4028 4.08531 16.9305 4.08531 17.2559 4.41075Z"
      fill="#E9E6FC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2559 4.41075C17.5814 4.73619 17.5814 5.26382 17.2559 5.58926L8.08926 14.7559C7.76382 15.0814 7.23618 15.0814 6.91074 14.7559L2.74408 10.5893C2.41864 10.2638 2.41864 9.73619 2.74408 9.41075C3.06951 9.08531 3.59715 9.08531 3.92259 9.41075L7.5 12.9882L16.0774 4.41075C16.4028 4.08531 16.9305 4.08531 17.2559 4.41075Z"
      fill="url(#paint0_radial_795_181831)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2559 4.41075C17.5814 4.73619 17.5814 5.26382 17.2559 5.58926L8.08926 14.7559C7.76382 15.0814 7.23618 15.0814 6.91074 14.7559L2.74408 10.5893C2.41864 10.2638 2.41864 9.73619 2.74408 9.41075C3.06951 9.08531 3.59715 9.08531 3.92259 9.41075L7.5 12.9882L16.0774 4.41075C16.4028 4.08531 16.9305 4.08531 17.2559 4.41075Z"
      fill="url(#paint1_radial_795_181831)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2559 4.41075C17.5814 4.73619 17.5814 5.26382 17.2559 5.58926L8.08926 14.7559C7.76382 15.0814 7.23618 15.0814 6.91074 14.7559L2.74408 10.5893C2.41864 10.2638 2.41864 9.73619 2.74408 9.41075C3.06951 9.08531 3.59715 9.08531 3.92259 9.41075L7.5 12.9882L16.0774 4.41075C16.4028 4.08531 16.9305 4.08531 17.2559 4.41075Z"
      fill="url(#paint2_radial_795_181831)"
      fillOpacity="0.8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2559 4.41075C17.5814 4.73619 17.5814 5.26382 17.2559 5.58926L8.08926 14.7559C7.76382 15.0814 7.23618 15.0814 6.91074 14.7559L2.74408 10.5893C2.41864 10.2638 2.41864 9.73619 2.74408 9.41075C3.06951 9.08531 3.59715 9.08531 3.92259 9.41075L7.5 12.9882L16.0774 4.41075C16.4028 4.08531 16.9305 4.08531 17.2559 4.41075Z"
      fill="url(#paint3_radial_795_181831)"
      fillOpacity="0.7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2559 4.41075C17.5814 4.73619 17.5814 5.26382 17.2559 5.58926L8.08926 14.7559C7.76382 15.0814 7.23618 15.0814 6.91074 14.7559L2.74408 10.5893C2.41864 10.2638 2.41864 9.73619 2.74408 9.41075C3.06951 9.08531 3.59715 9.08531 3.92259 9.41075L7.5 12.9882L16.0774 4.41075C16.4028 4.08531 16.9305 4.08531 17.2559 4.41075Z"
      fill="black"
      fillOpacity="0.1"
    />
    <defs>
      <radialGradient
        id="paint0_radial_795_181831"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.5816 15) rotate(-140.546) scale(17.048 31.1329)">
        <stop stopColor="#E9E6FC" stopOpacity="0" />
        <stop offset="1" stopColor="#C1BFF6" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_795_181831"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.4286 3.39286) rotate(139.525) scale(18.3105 29.4354)">
        <stop stopColor="#A178FE" />
        <stop offset="1" stopColor="#BEA1FE" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_795_181831"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.0408 4.16667) rotate(130.531) scale(15.7805 24.9184)">
        <stop stopColor="#E9E7FD" stopOpacity="0" />
        <stop offset="1" stopColor="#E9E7FD" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_795_181831"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2.5 4.16667) rotate(34.5379) scale(18.7668 42.1659)">
        <stop stopColor="#E9E6FC" stopOpacity="0" />
        <stop offset="0.501193" stopColor="#EDBFC5" stopOpacity="0.501193" />
        <stop offset="1" stopColor="#F1988F" />
      </radialGradient>
    </defs>
  </svg>
)
